<template>
  <div>
    <back-button default-to="/repairs" />
    <b-card no-header>
      <div class="d-flex mb-3">
        <b-button-group class="add-button-group ml-auto">
          <b-button v-if="detail" variant="primary" :href="printUrl" target="_blank"><font-awesome-icon icon="file-pdf" /> Cetak Surat Perbaikan</b-button>
          <b-button v-if="detail && canAct" class="ml-2" variant="info" :to="'/repairs/' + $route.params.id + '/edit'">Ubah</b-button>
        </b-button-group>
      </div>
      <b-alert v-if="detail" show variant="info">Pencatatan ini hanya masuk ke laporan perbaikan dan tidak mengubah stok.</b-alert>
      <b-row v-if="detail">
        <b-col cols="12" md="4"><detail-group-input label="No. Surat" :need-label="true" type="text" :value="detail.transaction_no" id="transaction_no" /></b-col>
        <b-col cols="12" md="4"><detail-group-input label="Tanggal perbaikan" :need-label="true" type="date" :value="detail.tanggal_perbaikan" id="tanggal_perbaikan" /></b-col>
        <b-col cols="12" md="4"><detail-group-input label="Nama barang" :need-label="true" type="text" :value="detail.nama_barang" id="nama_barang" /></b-col>
        <b-col cols="12" md="4"><detail-group-input label="Kadar" :need-label="true" type="text" :value="detail.kadar" id="kadar" /></b-col>
        <b-col cols="12" md="4"><detail-group-input label="Berat (gram)" :need-label="true" type="text" :value="detail.berat" id="berat" /></b-col>
        <b-col cols="12" md="4"><detail-group-input label="Biaya perbaikan" :need-label="true" type="price" :value="detail.biaya_perbaikan" id="biaya_perbaikan" /></b-col>
        <b-col cols="12"><detail-group-input label="Deskripsi kerusakan" :need-label="true" type="textarea" :value="detail.deskripsi_kerusakan" id="deskripsi_kerusakan" /></b-col>
      </b-row>
      <b-button to="/repairs" variant="secondary" class="float-right">Kembali</b-button>
    </b-card>
  </div>
</template>

<script>
import DetailGroupInput from '@/components/DetailGroupInput.vue'
import Repair from '@/models/Repair.js'

const repairModel = new Repair()

export default {
  components: { DetailGroupInput },
  data () { return { detail: null } },
  computed: {
    canAct () {
      const account = this.$store.getters['account/accountData']
      return account.role === 'admin' || Number(this.detail && this.detail.created_by) === Number(account.id)
    },
    printUrl () {
      return repairModel.endpoint + '/' + this.$route.params.id + '?print_pdf=1&access_token=' + this.$store.getters['account/accessToken']
    }
  },
  mounted () { this.getDetail() },
  methods: {
    async getDetail () {
      try {
        this.detail = await repairModel.find(this.$route.params.id)
      } catch (error) {
        this.$store.dispatch('notification/error', error)
      }
    }
  }
}
</script>
